export default __webpack_public_path__ + "static/media/done.6bd14375.svg";